module.exports = __webpack_public_path__ + "static/media/letter_m.cfd9d6ec.m4a";